import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/web/lib/styling";

const variants = cva(
  "inline-flex h-fit items-center justify-center gap-1 font-semibold uppercase",
  {
    variants: {
      variant: {
        solid: "bg-withus-dark-blue/3 text-withus-dark-blue",
        ghost: "bg-card/5 text-withus-white",
      },
      size: {
        sm: "px-2 py-2 text-xs [&_svg]:size-4",
        md: "px-2 py-2 text-sm [&_svg]:size-4",
        lg: "px-4 py-2 text-lg [&_svg]:size-5",
        xl: "px-4 py-2 text-xl [&_svg]:size-6",
      },
    },
    defaultVariants: {
      variant: "solid",
      size: "sm",
    },
  },
);

export function Badge({
  variant,
  className,
  size,
  ...props
}: React.ComponentProps<"div"> & VariantProps<typeof variants>) {
  return <div className={cn(variants({ variant, size, className }))} {...props} />;
}
